export class CookieHelper {
    private static isLocal: boolean = window.location.hostname.includes('localhost');
    private static domain: string = CookieHelper.isLocal ? '' : '.engagecrm.ai';

    static setCookie(name: string, value: string, hours: number = 8) {
        const expires = new Date();
        expires.setTime(expires.getTime() + hours * 60 * 60 * 1000);

        const domainAttr = this.domain ? `;domain=${this.domain}` : '';
        const secureAttr = this.isLocal ? '' : ';Secure;SameSite=None';

        document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/${domainAttr}${secureAttr}`;
    }

    static getCookie(name: string): string | null {
        const nameEQ = name + '=';
        const ca = document.cookie.split(';');
        for (let c of ca) {
            c = c.trim();
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
        }
        return null;
    }

    static eraseCookie(name: string) {
        const domainAttr = this.domain ? `;domain=${this.domain}` : '';
        const secureAttr = this.isLocal ? '' : ';Secure;SameSite=None';

        // must match setCookie attributes exactly
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/${domainAttr}${secureAttr}`;
    }
}
